import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import {
  useSetupAccountMutation,
  useSetupBookServiceMutation,
  useSetupUpdateAccountMutation,
} from "../../../../api/financeApi";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { GetProcDepartment } from "../../../../../utils/redux/Procurement/ProcurementSlice";
import { GetEmployeeBanks } from "../../../../../utils/redux/Employee/EmployeeSlice";
import { getPaymentType } from "../../../../../utils/redux/Finance/PaymentSetup/PaymentSetupSlice";

const AttachAccountDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const selectedAccount = JSON.parse(localStorage.getItem("selectedAccount"));

  if (selectedAccount) {
    console.log(selectedAccount);
  } else {
    console.log("no");
  }

  const { beneficiaries, departments } = useSelector((x) => x?.procurement);
  const { countries, banks, states, lgas, all_container } = useSelector(
    (state) => state?.employee
  );
  const paymentTypes = useSelector(
    (state) => state?.paymentSetup?.paymentTypes
  );

  useEffect(() => {
    // dispatch(GetNigerianStates());
    // dispatch(GetAssetType());
    // dispatch(GetAssets());
    dispatch(getPaymentType(10000, 1));
    dispatch(GetEmployeeBanks());
    dispatch(GetProcDepartment());
  }, []);

  // Dummy mutation function to replace with your actual API call
  const [onCreateService] = useSetupAccountMutation();
  const [onUpdateService] = useSetupUpdateAccountMutation();

  const [accounts, setAccounts] = useState([
    {
      paymentType: selectedAccount?.paymentTypeId || "",
      department: selectedAccount?.paymentTypeId || "",
      bankName: selectedAccount?.bank || "",
      accountName: selectedAccount?.cardName || "",
      accountNumber: selectedAccount?.accountNumber || "",
      cardNumber: selectedAccount?.cardNumber || "",
      containerId: selectedAccount?.containerId || "",
      expiryDate: selectedAccount?.expiryDate || "",
    },
  ]);

  // Function to handle input change
  const handleInputChange = (index, event) => {
    const values = [...accounts];
    values[index][event.target.name] = event.target.value;
    setAccounts(values);
  };

  // Function to add a new account form
  const addNewAccount = () => {
    setAccounts([
      ...accounts,
      {
        paymentType: "",
        department: "",
        bankName: "",
        accountName: "",
        accountNumber: "",
        containerId: "",
        cardNumber: "",
        expiryDate: "",
      },
    ]);
  };

 
 

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   setLoading(true);

  //   let allSuccessful = true; // Flag to check if all submissions are successful
  //   let failedAccounts = []; // To store account names for failed submissions
  //   let successfulAccounts = []; // To store account names for successful submissions

  //   // Loop through each account and submit one at a time
  //   for (let account of accounts) {
  //     try {
  //       const res = await onCreateService({
  //         paymentTypeId: account.paymentType,
  //         departmentId: account.department,
  //         cardNumber: account.cardNumber,
  //         containerId: account.containerId,
  //         bankId: account.bankName,
  //         cardName: account.accountName,
  //         accountNumber: account.accountNumber,
  //         expiryDate: account.expiryDate,
  //       }).unwrap();

  //       if (res?.successful) {
  //         successfulAccounts.push(account.accountName);
  //       } else {
  //         allSuccessful = false;
  //         failedAccounts.push(
  //           account.accountName +
  //             " - " +
  //             (res?.validationErrors[0] || "Unknown error")
  //         );
  //       }
  //     } catch (err) {
  //       allSuccessful = false;
  //       failedAccounts.push(
  //         account.accountName +
  //           " - " +
  //           (err?.data?.statusMessage || "Something went wrong")
  //       );
  //     }
  //   }

  //   if (allSuccessful) {
  //     toast.success("All data submitted successfully!");
  //   } else {
  //     if (successfulAccounts.length > 0) {
  //       toast.success(
  //         "Successfully submitted: " + successfulAccounts.join(", ")
  //       );
  //     }
  //     if (failedAccounts.length > 0) {
  //       toast.error("Failed to submit: " + failedAccounts.join(", "));
  //     }
  //   }
  //   setLoading(false);
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
  
    let allSuccessful = true; // Flag to check if all submissions are successful
    let failedAccounts = []; // To store account names for failed submissions
    let successfulAccounts = []; // To store account names for successful submissions
  
    // Loop through each account and submit one at a time
    for (let account of accounts) {
      try {
        // Determine whether to create or update based on selectedUser (or any condition)
        const serviceFunction = selectedAccount ? onUpdateService : onCreateService;
  
        const res = await serviceFunction({
          paymentTypeId: account.paymentType,
          departmentId: account.department,
          cardNumber: account.cardNumber,
          containerId: account.containerId,
          bankId: account.bankName,
          cardName: account.accountName,
          accountNumber: account.accountNumber,
          expiryDate: account.expiryDate,
          ...(selectedAccount && { id: selectedAccount?.id }), // If updating, include the userId or any relevant field
        }).unwrap();
  
        if (res?.successful) {
          successfulAccounts.push(account.accountName);
        } else {
          allSuccessful = false;
          failedAccounts.push(
            account.accountName +
              " - " +
              (res?.validationErrors[0] || "Unknown error")
          );
        }
      } catch (err) {
        allSuccessful = false;
        failedAccounts.push(
          account.accountName +
            " - " +
            (err?.data?.statusMessage || "Something went wrong")
        );
      }
    }
  
    if (allSuccessful) {
      toast.success("All data submitted successfully!");
    } else {
      if (successfulAccounts.length > 0) {
        toast.success(
          "Successfully submitted: " + successfulAccounts.join(", ")
        );
      }
      if (failedAccounts.length > 0) {
        toast.error("Failed to submit: " + failedAccounts.join(", "));
      }
    }
  
    setLoading(false);
  };
  

  const getContainersForPageItem = (data) => {
    // Check if data contains the required structure
    if (departments?.responseObject?.pageItems) {
      // Iterate through the items to find the object with the given id
      for (const item of departments?.responseObject?.pageItems) {
        if (item.id == accounts[data].department) {
          // console.log(item.containers);
          return item.containers;
        }
      }
    }
    return null; // Return null if no matching id is found
  };

  return (
    <RouteLayout title="Setup">
      <div className="p-5">
        <div className="flex gap-3 mb-5">
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Payment Setup /
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              {selectedAccount ? 'Edit' : "Attach"} Account Number
            </Typography>
          </div>
        </div>
        <div className="mb-5">
          <Button
            startIcon={<ArrowBackIcon />}
            variant=""
            style={{ marginRight: "10px" }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>

        <div className="mx-auto p-6 bg-white rounded-md shadow-sm">
          <h2 className="text-[26px] border-b pb-4 text-[#4B664C] font-[400] mb-6">
          {selectedAccount ? 'Edit' : "Attach"}  Account Number
          </h2>
          <div className="flex gap-6">
            <div className="min-w-[200px]">
              Account <br /> Details
            </div>
            <form className="flex-1" onSubmit={handleSubmit}>
              {accounts.map((account, index) => (
                <div key={index} className="border-b-2 mb-[40px] pb-[40px]">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Payment Type *
                      </label>
                      <select
                        name="paymentType"
                        value={account.paymentType}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                      >
                        <option value="">Select Payment Type</option>
                        {paymentTypes?.result?.map((data, index) => (
                          <option key={index} value={data?.id}>
                            {data?.name}
                          </option>
                        ))}{" "}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Department *
                      </label>
                      <select
                        name="department"
                        value={account.department}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                      >
                        <option value="">Select Department</option>
                        {departments?.responseObject?.pageItems.map(
                          (data, index) => (
                            <option key={index} value={data?.id}>
                              {data?.name}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Bank Name *
                      </label>
                      <select
                        name="bankName"
                        value={account.bankName}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                      >
                        <option value="">Select Bank</option>
                        {banks?.responseObject?.map((data, index) => (
                          <option key={index} value={data?.bankId}>
                            {data?.bankName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Account Name *
                      </label>
                      <input
                        type="text"
                        name="accountName"
                        value={account.accountName}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                        placeholder="Account Name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Account Number *
                      </label>
                      <input
                        type="text"
                        name="accountNumber"
                        value={account.accountNumber}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                        placeholder="Account Number"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Card Number *
                      </label>
                      <input
                        type="text"
                        name="cardNumber"
                        value={account.cardNumber}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                        placeholder="Account Number"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Expiry Date *
                      </label>
                      <input
                        type="date"
                        name="expiryDate"
                        value={account.expiryDate}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Containers *
                      </label>
                      <select
                        name="containerId"
                        value={account.containerId}
                        onChange={(e) => handleInputChange(index, e)}
                        className="mt-1 block w-full p-4 border border-gray-300 rounded-md"
                      >
                        <option value="">Select Container</option>
                        {getContainersForPageItem(index)?.map((data, index) => (
                          <option key={index} value={data?.id}>
                            {data?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              ))}

              {!selectedAccount && (
                <button
                  type="button"
                  onClick={addNewAccount}
                  className="flex items-center m-auto text-green-600 font-bold mt-4"
                >
                  <span className="text-xl mr-2">+</span> Add New Account
                  Details
                </button>
              )}

              <div className="flex justify-end mt-6">
                <button
                  type="button"
                  className="mr-4 py-2 px-4 bg-gray-300 text-gray-700 rounded-md"
                >
                  Cancel
                </button>
                {loading ? (
                  <button
                    disabled
                    className="py-2 px-4 bg-[#b3b3b3] text-white rounded-md"
                  >
                    loading...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="py-2 px-4 bg-green-600 text-white rounded-md"
                  >
                    Submit
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </RouteLayout>
  );
};

export default AttachAccountDetails;
